import "../styles/components/ImageCard.css";

type ImageCardFields = {
  icon: string;
  addBreak?: boolean;
  content: string[];
  title?: string;
  link?: string;
};

const ImageCard: React.FC<ImageCardFields> = ({
  icon,
  content,
  title,
  link,
  addBreak = false,
}) => {
  return (
    <a href={link} style={{textDecoration: "none", color: "black"}} target="_blank" rel="noreferrer" className="card">
      <img alt="imageCard" className="icon" src={icon} />
      {addBreak && <br />}
      <p className="textCard">
        <b>{title}</b>
          <br />
          {content.map((val) => (
            <>
              {val} <br />
            </>
          ))}
      </p>
    </a>
  );
};

export default ImageCard;
